import React from 'react';
import { ChevronRight } from 'lucide-react';
export function WeddingPackagesSection() {
  return <section id="packages" className="relative min-h-[60vh] overflow-hidden" data-id="element-420">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url(https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/lr.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-id="element-421" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-10" data-id="element-422" />

      {/* Content Container */}
      <div className="relative z-20 py-20 px-8" data-id="element-423">
        <div className="text-center text-white max-w-4xl mx-auto" data-id="element-424">
          {/* Decorative Accent Line */}
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-425" />

          {/* Eyebrow Label */}
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-426">
            Packages
          </div>

          {/* Heading */}
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-6 leading-tight" data-id="element-427">
            Wedding Packages
          </h2>

          {/* Description */}
          <p className="text-lg text-white mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-428">
            Explore our carefully curated wedding packages designed to make your
            special day unforgettable. Download the details to find the perfect
            fit for your celebration.
          </p>

          {/* Wedding Package Buttons - Stacked Layout */}
          <div className="flex flex-col items-center gap-6 max-w-2xl mx-auto" data-id="element-429">
            {/* Primary Button - Large Outline Style */}
            <div className="relative w-full max-w-md" data-id="element-430">
              <a href="/path-to-wedding-package.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 border-2 border-white text-white px-10 py-5 text-lg hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-sm group w-full" data-id="element-431">
                Wedding Package
                <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-432" />
              </a>
            </div>

            {/* Secondary Buttons - Smaller, Side by Side */}
            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-md" data-id="element-433">
              <a href="/path-to-micro-wedding-package.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-5 py-3 text-sm hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-sm group flex-1" data-id="element-434">
                Micro Wedding
                <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-435" />
              </a>
              <a href="/path-to-wedding-extras.pdf" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border-2 border-white text-white px-5 py-3 text-sm hover:bg-white hover:text-brand-grey transition-colors font-medium rounded-sm group flex-1" data-id="element-436">
                Wedding Extras
                <ChevronRight size={14} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-437" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}